import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pennyworld/PWW_Communities_nolabel.png")